import React from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';

export function snackbarRouteSaveSuccess({ t, enqueueSnackbar, code }) {
  enqueueSnackbar(t('notifications.routeSaveSuccess', { code }), { variant: 'success' });
}

export function snackbarRouteSaveError({ t, enqueueSnackbar, code, errorCode }) {
  enqueueSnackbar(t('notifications.routeSaveError', { code, errorCode }), { variant: 'error' });
}

export function snackbarRouteCannotBeEdited({ t, enqueueSnackbar }) {
  enqueueSnackbar(t('notifications.routeCannotBeEdited'),
    {
      autoHideDuration: null,
      action: <IconButton color="inherit"><Clear/></IconButton>,
    });
}

export function snackbarNotFoundAddresses({ t, enqueueSnackbar, count, onViewClick }) {
  enqueueSnackbar(t('notifications.notFoundAddresses', { count }),
    {
      variant: 'warning',
      autoHideDuration: null,
      action: [
        <Button key="view" color="inherit" size="small" onClick={onViewClick}>{t('buttons.view')}</Button>,
        <IconButton key="close" color="inherit"><Clear/></IconButton>,
      ],
    });
}

export function snackbarNotGeoAddresses({ t, enqueueSnackbar, count, onViewClick }) {
  enqueueSnackbar(t('notifications.notGeolocatedAddresses', { count }),
    {
      variant: 'warning',
      autoHideDuration: null,
      action: [
        <Button key="view" color="inherit" size="small" onClick={onViewClick}>{t('buttons.view')}</Button>,
        <IconButton key="close" color="inherit"><Clear/></IconButton>,
      ],
    });
}

export function snackbarRouteReloaded({ t, enqueueSnackbar, code }) {
  enqueueSnackbar(t('notifications.routeReloaded', { code }), { variant: 'success' });
}



// WEBPACK FOOTER //
// ./src/helpers/snackbars.js